import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class SilentErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    // Silently handle errors without logging to console
    // You can optionally add custom error handling logic here
    // For example, sending errors to a monitoring service
  }
}
